var map = {
	"./dashboard/dashboard.module.ngfactory": [
		"uP/6",
		8
	],
	"./items/items.module.ngfactory": [
		"f2cM",
		2,
		12
	],
	"./order-templates/order-templates.module.ngfactory": [
		"hcW7",
		3,
		13
	],
	"./orders/orders.module.ngfactory": [
		"F/Pw",
		3,
		9
	],
	"./products/products.module.ngfactory": [
		"G8AK",
		2,
		1,
		11
	],
	"./units/units.module.ngfactory": [
		"Li1q",
		1,
		10
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;